export default "__VITE_ASSET__BwU6gWI5__"